export default __webpack_public_path__ + "static/media/36I-102728_-15733_0.cd257806.jpg";